module.exports = __webpack_public_path__ + "static/media/image-576.8d7f9ded.webp";